// extracted by mini-css-extract-plugin
export default {"templateImageFallback":"BtRPoh"};